import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ModalPortal from '../ModalPortal';
import VERTICAL_CONFIG from '../../constants/verticalConfig';
import './ModalEnrollClient.css';

const propTypes = {
  client: PropTypes.object,
  onSubmit: PropTypes.func,
};

const defaultProps = {
  client: null,
  onSubmit: () => {},
};

class ModalEnrollClient extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      product: '',
      method: null,
    };
  }

  handleUpdate = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit({
      product: this.state.product,
      method: this.state.method,
    });
  };

  hide() {
    window.$(this.modal).modal('hide');
  }

  show() {
    window.$(this.modal).modal('show');
  }

  render() {
    const { client } = this.props;
    return (
      <ModalPortal>
        <div
          className="ModalEnrollClient modal"
          id="enrollClientModal"
          ref={(c) => (this.modal = c)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content-wrapper">
              <form className="form" onSubmit={this.handleSubmit}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Create offer</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Please select the product and the method of marketing.
                    </p>
                    <div className="form-group">
                      <label htmlFor="product" className="text-uppercase">
                        Product
                      </label>
                      <select
                        className="form-control"
                        id="product"
                        name="product"
                        value={this.state.product || ''}
                        aria-required="true"
                        onChange={this.handleUpdate}
                      >
                        <option value="">Select one</option>
                        {VERTICAL_CONFIG.IS_BOA_ENABLED &&
                          client.client_type === 'business' && (
                            <option value="chubb_boa">
                              Business Owner Accident
                            </option>
                          )}
                        {VERTICAL_CONFIG.IS_PASSPORT360_ENABLED &&
                          client.client_type === 'individual' && (
                            <option value="chubb_passport360">
                              Passport 360
                            </option>
                          )}
                      </select>
                    </div>
                    <label className="text-uppercase">
                      Method of enrollment
                    </label>
                    <div className="radio radio-success">
                      <input
                        id="radioEmail"
                        type="radio"
                        name="method"
                        value="email"
                        checked={this.state.method === 'email'}
                        onChange={this.handleUpdate}
                      />
                      <label
                        className="ModalEnrollClient-radio form-check-label"
                        htmlFor="radioEmail"
                      >
                        <strong className="ModalEnrollClient-radio-label">
                          Send offer link via Email
                        </strong>
                        <p className="ModalEnrollClient-radio-info">
                          Your client will be sent an email with a link to a
                          landing page. Once the application is completed, you
                          will receive an update on any change in status.
                        </p>
                      </label>

                      <input
                        id="radioManual"
                        type="radio"
                        name="method"
                        value="manual"
                        checked={this.state.method === 'manual'}
                        onChange={this.handleUpdate}
                      />
                      <label
                        className="ModalEnrollClient-radio form-check-label"
                        htmlFor="radioManual"
                      >
                        <strong className="ModalEnrollClient-radio-label">
                          Send a customized proposal or manually bind coverage
                        </strong>
                        <p className="ModalEnrollClient-radio-info">
                          Prepare a customized proposal that will be sent to the
                          client via email, or instantly bind coverage on their
                          behalf.
                        </p>
                      </label>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-complete"
                      disabled={!this.state.product || !this.state.method}
                    >
                      Send offer
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}

ModalEnrollClient.propTypes = propTypes;
ModalEnrollClient.defaultProps = defaultProps;

export default ModalEnrollClient;
